import { ContinuationedResponse } from '@/types';
import { InfiniteQueryConfigOptions } from '@reduxjs/toolkit/query';

export const getContinuationTokenInfiniteQueryOptions = <
  T extends ContinuationedResponse
>(): InfiniteQueryConfigOptions<T, Pick<T, 'continuationToken'>> => ({
  initialPageParam: { continuationToken: undefined },
  getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => {
    if (lastPage.data.length === 0) return undefined;
    return { continuationToken: lastPage.continuationToken };
  },
});
